import React, { PureComponent } from 'react';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { Table } from 'reactstrap';
import { string, bool, array, func, number } from 'prop-types';
import FlowLandingsTableItem from './FlowLandingsTableItem';
import FlowDomainTableItem from './FlowDomainTableItem';

const getStreamCr = (items = [], landId) => {
  const item = items.find(({ id }) => id === landId);
  return item ? item.streamCr : 0;
};

class FlowLandingsTable extends PureComponent {
  static propTypes = {
    landings: array.isRequired,
    name: string.isRequired,
    checked: array,
    onLandingChange: func,
    multiple: bool,
    showStreamCr: bool,
    domains: array,
    offerId: number,
    abTest: bool,
    abTestDisabled: bool,
    streamLandings: array,
  };

  static defaultProps = {
    domains: [],
    landings: [],
    checked: [0],
    showStreamCr: true,
    abTest: true,
    streamLandings: [],
  };

  render() {
    const {
      landings,
      domains,
      checked,
      onLandingChange,
      name,
      multiple,
      showStreamCr,
      offerId,
      abTest,
      toggleIframeConstructorModal,
      site_key,
      offer,
      streamId,
      inFlow,
      inDomain,
      intl,
      checkedLandings,
      checkedTransits,
      landingsTableType,
      abTestEnabled,
      topItem,
      abTestDisabled,
      theme,
      streamLandings
    } = this.props;
    const {
      modifies: { is_cdn },
    } = offer;

    // find landing with max Cr to attach tag to
    const maxCrLanding = landings && landings.reduce((acc, v) => {
      return acc.totalCr < v.totalCr ? v : acc
    }, {totalCr: 0, id: -1});

    return (
      <Table className="flow-landings-table no-margin" bordered responsive>
        <thead>
          <tr>
            <th className="controls" />
            <th className="platform" />
            <th className="title" colSpan="2">
              {/* {theme === 4 && landingsTableType === 'landings' ? (
                <FormattedMessage
                  id="flow.landings.choose.theme_4"
                  defaultMessage="Choose landing"
                />
              ) : theme === 4 && landingsTableType === 'transits' ? (
                <FormattedMessage
                  id="flow.prelander.choose.theme_4"
                  defaultMessage="Choose prelander"
                />
              ) : ( */}
                <FormattedMessage id="flow.landings-table.title" defaultMessage="Title" />
              {/* )} */}
            </th>
            <th />
            {showStreamCr && (
              <th className="values">
                <FormattedHTMLMessage
                  id="flow.landings-table.cr-flow"
                  defaultMessage="CR by&nbsp;flow,&nbsp;%"
                  tagName="span"
                />
              </th>
            )}

            <th className="values">
              <FormattedHTMLMessage
                id="flow.landings-table.cr-system"
                defaultMessage="CR by&nbsp;system,&nbsp;%"
                tagName="span"
              />
            </th>
            {is_cdn ? <th>{''}</th> : null}
          </tr>
        </thead>
        {landings.length > 0 && (
          <tbody>
            {landings.map(landing => (
              <FlowLandingsTableItem
                theme={theme}
                key={landing.id}
                offerId={offerId}
                name={name}
                checked={checked}
                multiple={multiple}
                showStreamCr={showStreamCr}
                onLandingChange={({ target }) => onLandingChange(parseInt(target.value, 10))}
                abTest={abTest}
                toggleIframeConstructorModal={toggleIframeConstructorModal}
                offer={offer}
                streamId={streamId}
                {...landing}
                site_key={site_key}
                inFlow={inFlow}
                inDomain={inDomain}
                intl={intl}
                landingsTableType={landingsTableType}
                checkedLandings={checkedLandings}
                checkedTransits={checkedTransits}
                abTestEnabled={abTestEnabled}
                isTop={landing.id === topItem}
                abTestDisabled={abTestDisabled}
                maxCrLandingId={maxCrLanding.id}
                streamCr={getStreamCr(streamLandings, landing.id)}
              />
            ))}
          </tbody>
        )}

        {domains.length > 0 && (
          <tbody>
            {domains.map(domain => (
              <FlowDomainTableItem
                key={domain.id}
                checked={checked}
                onLandingChange={({ target }) => onLandingChange(target.value)}
                name={name}
                multiple={multiple}
                showStreamCr={showStreamCr}
                abTest={abTest}
                excludeFromABChecker
                abTestDisabled={abTestDisabled}
                {...domain}
              />
            ))}
          </tbody>
        )}
      </Table>
    );
  }
}

export default injectIntl(FlowLandingsTable);
